import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import lang_en from './translations/language/en.json';
import lang_tr from './translations/language/tr.json';

import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'tr', // language to use
  resources: {
    en: {
      language: lang_en, // 'language' is our custom namespace
    },
    tr: {
      language: lang_tr,
    },
  },
  react: { transKeepBasicHtmlNodesFor: ['br', 'i', 'b', 'p', 'strong'] },
});

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
